import {handleValidationChange} from '../CommonValidation';

export const validateAdjustment = (data, setIsError) => {

    var isValid = true;

    

    if(data.counted_by === "" || data.counted_by === null || data.counted_by === undefined) {
        handleValidationChange("counted_by", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("counted_by", false, setIsError);
    }

    if(data.type_id === "" || data.type_id === undefined || data.type_id === null) {
        handleValidationChange("type_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("type_id", false, setIsError);
    }

    if(data.physical_count === "" || data.physical_count === null || data.physical_count === undefined) {
        handleValidationChange("physical_count", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("physical_count", false, setIsError);
    }

    if(data.difference === "" || data.difference === undefined || data.difference === null) {
        handleValidationChange("difference", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("difference", false, setIsError);
    }

    return isValid
  
}
